var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardsingame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17207 0.66786C9.75393 0.577078 10.338 0.777662 10.6445 1.29166L16.2668 12.4638C16.5422 13.0569 16.4579 13.7248 15.9495 14.1627C13.2784 15.5716 10.5619 16.9622 7.81035 18.2059C7.3893 18.2686 6.84115 18.068 6.5714 17.7386C4.55087 13.8394 2.53725 9.90723 0.678397 5.93188C0.609231 5.40059 0.83359 4.90735 1.25767 4.59091L8.82191 0.792792C8.92998 0.756047 9.06227 0.684719 9.17207 0.667427V0.66786ZM15.0162 13.1658L9.48634 2.05638L2.05006 5.70579L7.64737 16.8321L15.0158 13.1658H15.0162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.575 11.4866L15.1917 8.79001V2.33979H11.9711L11.2578 0.959045H15.3862C15.8591 0.959045 16.575 1.67362 16.575 2.14569V11.4866Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2666 2.81464L20.852 4.60778C21.3773 5.01976 21.5778 5.70969 21.2809 6.32485L17.2666 14.2911V11.2495L20.0346 5.72872L17.2666 4.36786V2.81464Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4726 16.8368C15.6615 16.8156 15.9287 16.7101 16.099 16.6211C15.7294 17.6136 15.1233 18.5534 13.9086 18.0956L11.4307 16.8368H15.4726Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6787 16.1464L16.1294 14.9035L16.5746 14.5499C16.6213 15.0851 16.39 15.6648 15.9132 15.9389C15.8233 15.9903 15.4649 16.1464 15.3863 16.1464H13.6787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsingame);
export default __webpack_public_path__ + "static/media/cardsingame.5894d9aa457b500abde09e391683ca4e.svg";
export { ForwardRef as ReactComponent };